const choiceReducer = (state = {}, action) => {
  switch (action.type) {
    case "SET_CHOICE":
      return action.payload;
    default:
      return state;
  }
};

export default choiceReducer;
